export enum DatePart {
  Hourly = 'hour',
  Daily = 'day',
  Weekly = 'week',
  Monthly = 'month',
  Quarterly = 'quarter'
}
